<template>
    <div>
        <v-card height="100%">
            <v-toolbar flat height="unset" class="py-2">
                <p class="line" style="margin: 0"></p>
                <v-toolbar-title class="pl-4 subtitle-1 font-weight-bold ma-0 primary--text" style="white-space: normal;">
                    Proyección
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                    :disabled="!period || !date_start || !date_end || !rate"
                    :loading="simulate.status == 'loading'"
                    color="accent" 
                    small 
                    @click="doSimulation"
                    class="mr-3">Simular</v-btn>
                <v-btn
                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                    :disabled="!changes"
                    color="accent" 
                    @click="save"
                    small>Guardar</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-0 py-md-3">
                <v-row>
                    <v-col class="px-3 "> 
                        <v-row>
                            <v-col class="py-0">
                                <v-row>
                                    <v-col cols="6" class="pa-1 pa-md-3">
                                        <v-menu
                                            :disabled="!userAtLeastIs(user, LEVEL_ADMIN)"
                                            ref="start"
                                            v-model="start_menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date_start"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="date_start_formated"
                                                hide-details
                                                dense
                                                outlined
                                                flat
                                                label="Fecha inicial"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date_start" no-title scrollable @input="changes = true" locale="es">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="start_menu = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.start.save(date_start)">OK</v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6" class="pa-1 pa-md-3">
                                        <v-text-field
                                            v-model="date_end_formated"
                                            dense
                                            outlined
                                            flat
                                            hide-details
                                            label="Fecha final"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="pa-1 pa-md-3">
                                <v-select
                                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                                    v-model="period"
                                    :items="[{
                                        text: 'Bimestral',
                                        value: 2
                                    },{
                                        text: 'Mensual',
                                        value: 1
                                    }]"
                                    @change="changes = true"
                                    label="Periodo"
                                    dense
                                    hide-details
                                    outlined
                                    flat
                                    solo
                                ></v-select>
                                <v-text-field
                                    v-else
                                    label="Periodo"
                                    dense
                                    outlined
                                    flat
                                    hide-details
                                    readonly
                                    :value="period === 1 ? 'Mensual': 'Bimestral'"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="pa-1 pa-md-3">
                                <v-select
                                    v-if="userAtLeastIs(user, LEVEL_ADMIN)"
                                    v-model="rate"
                                    :items="rates"
                                    item-text="name"
                                    item-value="name"
                                    @change="changes = true"
                                    label="Tarifa"
                                    hide-details
                                    dense
                                    outlined
                                    flat
                                    solo
                                ></v-select>
                                <v-text-field
                                    v-else
                                    v-model="rate"
                                    label="Tarifa"
                                    dense
                                    outlined
                                    flat
                                    hide-details
                                    readonly
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="d-flex">
                        <div class="text-center ma-auto" v-if="!simulate.status">
                            <v-icon x-large color="accent">mdi-chart-box-plus-outline</v-icon>
                            <p>Ingresar datos</p>
                        </div>
                        <div v-else class="text-center ma-auto">
                            <p class="font-weight-bold mb-1">Se estima un monto a pagar de</p>
                            <p class="text-h5 font-weight-bold accent--text mt-1 simulate-text" v-if="simulate.status === 'done'"> 
                                <span class="ma-1">$</span> {{simulate.value}} <span class="ma-1">MXN</span> 
                            </p>
                            <p v-else>
                                <v-progress-circular
                                    :size="50"
                                    color="primary"
                                    indeterminate
                                ></v-progress-circular>
                            </p>
                        </div>
                    </v-col>
                </v-row>
                
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { FIXED, PROPORTIONAL } from '../../plugins/rates'
import { userAtLeastIs, LEVEL_ADMIN } from '../../plugins/checkPermission'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'simulator',
    props: ['gateway', 'meters'],
    computed:{
        ...mapState({
            rates: state => state.account.profile.rates,
            user: state => state.user.profile.level
        }),
        date_start_formated(){
            if(!this.date_start ) return
            let date = new Date(this.date_start)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            const [year, month, day] = date.toISOString().substr(0, 10).split('-')
            return `${day}/${month}/${year}`
        },
        date_end(){
            if(!this.date_start || !this.period) 
                return null
            let date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            return date.toISOString().substr(0, 10)
        },
        date_end_formated(){
            if(!this.date_start || !this.period) 
                return null
            let date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            const [year, month, day] = date.toISOString().substr(0, 10).split('-')
            return `${day}/${month}/${year}`
        }
    },
    data() {
        return {
            simulate:{
                status: null,
                value: 0
            },
            date_start: null,
            start_menu: null,
            rate: null,
            period: null,
            changes: false,
            LEVEL_ADMIN,
            FIXED, PROPORTIONAL
        }
    },
    methods:{
        ...mapActions({ 
            saveChanges: 'gateways/saveSimulation',
            queryReadings: 'meters/queryReadings',
            getSummaryData: 'meters/getSummaryData'
        }),
        userAtLeastIs,
        setData(){
            if(!this.gateway.rate) return null
            this.simulate.status = null
            this.simulate.value = 0
            this.rate = this.gateway.rate
            this.period = this.gateway.period
            this.date_start = this.gateway.start_period
            this.changes = !this.period || !this.date_start || !this.date_end || !this.rate ? true: false
            this.checkDateStart()
            if(this.date_start && this.rate && this.period)
                this.doSimulation()
        },
        checkDateStart(){
            if(!this.date_start) return
            const date = new Date(this.date_start)
            date.setMonth(date.getMonth() + this.period)
            date.setTime(date.getTime() + (1000 * 60 * 60 * 6))
            
            if(new Date().getTime() < date.getTime())
                return
            
            this.date_start = date.toISOString().substr(0, 10)
            this.save()
        },
        async doSimulation(){
            this.simulate.status = 'loading'

            const req_start = []
            this.meters.forEach( m =>{
                req_start.push(this.queryReadings({ meter: m.name, query: { start: new Date(this.date_start).getTime()  + (1000 * 60 * 60 * 6), cnt: 1 }}))
            })

            const req_end = []
            this.meters.forEach( m =>{
                req_end.push(this.queryReadings({ meter: m.name, query: { cnt: 1 }}))
            })

            try {
                const rate = this.rates.find( r => r.name === this.rate )
                let consumption, base, demand

                const start_reads = await Promise.all(req_start)
                const end_reads = await Promise.all(req_end)

                const start_value = start_reads.reduce((sum, read) => sum + read[0].lines[0].kwht, 0)
                const end_value = end_reads.reduce((sum, read) => sum + read[0].lines[0].kwht, 0)
                
                const total_days = Math.round((new Date(this.date_end).getTime() - new Date(this.date_start).getTime()) / (1000 * 60 * 60 * 24))
                const current_days = Math.round((new Date().getTime() - new Date(this.date_start).getTime()) / (1000 * 60 * 60 * 24))
                const kwh_day = (end_value - start_value) / current_days
                const price = rate.price
                
                consumption = (((end_value - start_value) * price) + (((total_days - current_days) * kwh_day) * price)).toFixed(2)

                rate.base && (rate.rate === this.FIXED || rate.rate === this.PROPORTIONAL) ? base = rate.base : base = 0
                if(rate.rate === this.PROPORTIONAL && rate.demand){
                    const meter = this.meters.find( m => m.type === 'consumption' )
                    if(meter){
                        const summary_data = await this.getSummaryData({ meters: [meter], type: 'month', options: { start: new Date(this.date_start).getTime(), end: new Date().getTime() }})
                        const watts_max = summary_data[0].reduce((watts, read)=>{
                            let max = 0
                            read.lines.forEach( l => max = l.watts > max ? l.watts:  max )
                            return watts > max ? watts: max 
                        }, 0)
                        demand = (watts_max / 1000) * parseFloat(rate.demand)
                    }
                }else demand = 0
                
                this.simulate.value = (parseFloat(consumption) + parseFloat(base) + parseFloat(demand)).toFixed(2)
                this.simulate.status = 'done'
            } catch (error) {
                console.log(error)
                this.simulate.status = null
            }
        },
        async save(){
            try {
                await this.saveChanges({
                    gateway: this.gateway.id ,
                    period: this.period,
                    rate: this.rate,
                    start: this.date_start
                })
                this.changes = false
            } catch (error) {
                console.log(error)
            }
        }
    },
    watch:{
        gateway(){
            this.setData()
        }
    },
    mounted(){
        this.setData()
    }
}
</script>

<style scoped>
    .line{
        border-left: 2px solid var(--v-primary-base);
        height: 13px;
    }
    .simulate-text{
        display: inline-flex;
        align-items: center;
    }
    .simulate-text > span {
        font-size: 15px;
    }
</style>